export function authHeader () {
  // return authorization header with token
  let currentUser = JSON.parse(localStorage.getItem('currentUser'))

  if (currentUser) {
    return {
      'Authorization': 'Bearer ' + currentUser.token
    }
  } else {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/authHeader.js